module.exports = __webpack_public_path__ + "static/media/the_microf_story_placeholder.8b3b7ee2.png";